<template>
  <v-expansion-panel-header class="font-weight-bold white--text">
    <v-row dense>
      <v-col sm="12" md="2">
        {{ match.commande.numero }} (ligne {{ match.commande.ligne }})
      </v-col>
      <v-col sm="12" md="2">
        {{ nbMonnaie(match.commande.montant) }}
      </v-col>
      <v-col sm="12" md="6">
        {{ match.commande.description }}
      </v-col>
    </v-row>
  </v-expansion-panel-header>
</template>

<script>
import { libUtilMixin } from "@/mixins/libUtilMixin";

export default {
  name: "VueShowCommandHeader",
  mixins: [libUtilMixin],
  props: {
    match: {
      type: Object,
      required: true,
    },
  },
};
</script>
